import React from 'react';
import classNames from 'classnames/bind'
import { useHistory } from 'react-router-dom'

import { FluidImage } from "components/shared/fluid-image/FluidImage"
import { SectionDivider } from "components/shared/sectionDivider/SectionDivider";
import { WebCategory } from 'components/pages/homePage/webCategory/WebCategory'
import { WebCategoryMobile } from 'components/pages/homePage/webCategoryMobile/WebCategoryMobile'

import styles from './home-page.module.scss';

const cx = classNames.bind(styles)

export const HomePage = () => {
	const history = useHistory()
	const webCategories = {
		desktop: [
			{
				altText: 'Tampa Bay Web Developer',
				image: './images/home/tampa-web-developer-2.jpg',
				link: '/about',
				title: 'Click to learn more about this Tampa Bay Area web developer.',
				label: 'About Justin',
				fadeInDirection: 'left'
			},
			{
				altText: 'Web Developer Skills',
				image: './images/home/tampa-web-developer-skills.jpg',
				link: '/skills/',
				title: 'Click to view skills of the Tampa Bay web developer.',
				label: 'Skills',
				fadeInDirection: 'top'
			},
			{
				altText: 'Web Developer Blog',
				image: './images/home/tampa-web-developer-blog.jpg',
				link: '/blog',
				title: 'Click to view blogs of this Tampa Bay web developer.',
				label: 'Blog',
				fadeInDirection: 'right'
			}
		],
		mobile: [
			{
				altText: 'Tampa Bay Web Developer',
				image: './images/home/tampa-web-developer-2-mobile.jpg',
				link: './about',
				title: 'Click to learn more about this Tampa Bay Area web developer.',
				label: 'About Justin',
				fadeInDirection: 'left'
			},
			{
				altText: 'Web Developer Skills',
				image: './images/home/tampa-web-developer-skills-mobile.jpg',
				link: './skills/',
				title: 'Click to view skills of the Tampa Bay web developer.',
				label: 'Skills',
				fadeInDirection: 'top'
			},
			{
				altText: 'Web Developer Blog',
				image: './images/home/tampa-web-developer-blog-mobile.jpg',
				link: '/blog',
				title: 'Click to view blogs of this Tampa Bay web developer.',
				label: 'Blog',
				fadeInDirection: 'right'
			}
		]
	}

	const handleButtonClick = () => {
		history.push('/portfolio')
	}

	return (
		<div className={cx("home-page-wrapper")}>
			<div className={cx(["container", "hero-container", "animate__animated", "animate__fadeIn"])}>
				<FluidImage altText='Web Developer Hero Banner' image='/images/home/home-main-banner.jpg' />
				<div className={cx('view-portfolio-button-wrapper')}>
					<button className={cx(['primary-button', 'hero-button'])} onClick={()=>handleButtonClick()}  title="Click to view">View Portfolio</button>
				</div>
			</div>

			<SectionDivider />

			<div className={cx(["website-categories", "animate__animated", "animate__fadeIn", "animate__delay-.1s"])}>
				<div className={cx(['container', 'website-categories-inner-wrapper'])}>
					<div className={cx("row")}>
						{webCategories.desktop.map( (webCategory, index) => {
							return (
								<WebCategory {...webCategory} key={index}/>
							)
						})}

						{webCategories.mobile.map( (webCategory, index) => {
							return (
								<WebCategoryMobile {...webCategory} key={index}/>
							)
						})}

						{/*<div className={cx(["col", "col-12", "col-md-4", "animate__animated", "animate__fadeInUp"])}>*/}
						{/*	<FluidImage altText="Web Developer Labs" image="./images/home/tampa-web-developer-labs.jpg" />*/}
						{/*	<h3>*/}
						{/*		<NavLink*/}
						{/*			to="./labs"*/}
						{/*			title="Click to view the Tampa Bay Area web developers miscellaneous labs.">*/}
						{/*			Labs*/}
						{/*		</NavLink>*/}
						{/*	</h3>*/}
						{/*</div>*/}


						{/*<div className="col col-md-4 radar-wrapper">*/}
						{/*<RadarChart cx={275} cy={150} outerRadius={100} width={577} height={235} data={this.data} className="radar-chart">*/}
						{/*<PolarGrid />*/}
						{/*<PolarAngleAxis dataKey="skill" />*/}
						{/*<PolarRadiusAxis/>*/}
						{/*<Radar name="Justin" dataKey="A" stroke="#000033" fill="#00aeef" fillOpacity={0.65}/>*/}
						{/*</RadarChart>*/}
						{/*<h3><a title="Click to view the Tampa Bay Area web developers skills.">Skills</a></h3>*/}
						{/*</div>*/}
					</div>
				</div>
			</div>
		</div>
	)
}